import React, {useState} from "react";
import {Button, message, Table, Tooltip} from "antd";
import {SendOutlined} from "@ant-design/icons";
import moment from "moment";
import {useStore} from "../../../../../hooks/useStore";
import {formatMoney} from "../../../../../utils/moneyHelper";

const isEarningInvoice = invoice => invoice?.invoiceType === "earning";

/**
 * isCourierActive: false olan kuryeler için fatura bekleyen courierInvoice kayıtlarını listeler.
 * Her satırdan iade faturası SMS'i tekrar gönderilebilir.
 */
export const CourierInvoicesExpandedRow = ({courierId, invoices = []}) => {
    const stores = useStore();
    const [sendingId, setSendingId] = useState(null);

    const handleSendReturnSms = async invoice => {
        const courierInvoiceId = invoice._id;
        setSendingId(courierInvoiceId);
        const result = await stores.walletStore.sendReturnSms({courierId, courierInvoiceId});
        if (result) {
            message.success(
                isEarningInvoice(invoice)
                    ? "Hakediş faturası SMS'i gönderildi."
                    : "İade faturası SMS'i gönderildi."
            );
        }
        setSendingId(null);
    };

    const columns = [
        {
            title: "Fatura Numarası",
            dataIndex: "invoiceNumber",
            key: "invoiceNumber",
            render: invoiceNumber => invoiceNumber || "-"
        },
        {
            title: "Tutar",
            dataIndex: "invoiceAmount",
            key: "invoiceAmount",
            render: invoiceAmount => formatMoney({amount: invoiceAmount})
        },
        {
            title: "Fatura Tipi",
            dataIndex: "invoiceType",
            key: "invoiceType",
            render: invoiceType =>
                !invoiceType
                    ? "-"
                    : invoiceType === "earning"
                    ? "Hakediş Faturası"
                    : "İade Faturası"
        },
        {
            title: "Durum",
            dataIndex: "status",
            key: "status",
            render: status => status || "-"
        },
        {
            title: "Oluşturulma Tarihi",
            dataIndex: "createdAt",
            key: "createdAt",
            render: createdAt => (createdAt ? moment(createdAt).format("DD.MM.YYYY HH:mm") : "-")
        },
        {
            title: "İşlemler",
            key: "actions",
            align: "center",
            render: (_, invoice) => (
                <Tooltip
                    title={
                        isEarningInvoice(invoice)
                            ? "Hakediş Faturası SMS'i Gönder"
                            : "İade Faturası SMS'i Gönder"
                    }
                >
                    <Button
                        type="primary"
                        size="small"
                        icon={<SendOutlined />}
                        loading={sendingId === invoice._id}
                        onClick={() => handleSendReturnSms(invoice)}
                    />
                </Tooltip>
            )
        }
    ];

    return (
        <Table
            size="small"
            pagination={false}
            rowKey="_id"
            columns={columns}
            dataSource={invoices}
        />
    );
};
